module.exports = __webpack_public_path__ + "media/images/success-56c05355734c825293698afa051ed4bf.png";